import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

import BaseLink from '@/components_new/BaseLink.vue'
import Icon from '@/components_new/Icon/Icon.vue'
import Typography from '@/components_new/Typography.vue'
import { useConfig } from '@/composables/config'

import AndroidAppBadgeImg from '../images/android_image.svg'


export default /*@__PURE__*/_defineComponent({
  __name: 'AndroidBadge',
  setup(__props) {

const { VUE_APP_ANDROID_APP_URL } = useConfig()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseLink, {
    externalTo: _unref(VUE_APP_ANDROID_APP_URL),
    target: "_blank",
    class: _normalizeClass(_ctx.$style.android_link)
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: _unref(AndroidAppBadgeImg),
        alt: "Playgama Android",
        loading: "lazy",
        class: _normalizeClass(_ctx.$style.android_badge)
      }, null, 10, _hoisted_1),
      _createVNode(Typography, {
        size: "s",
        class: _normalizeClass(_ctx.$style.android_link_desc),
        accent: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$tr('navigation.android_app_link')), 1)
        ]),
        _: 1
      }, 8, ["class"]),
      _createVNode(Icon, {
        name: "chevron_r",
        class: _normalizeClass(_ctx.$style.android_link_icon)
      }, null, 8, ["class"])
    ]),
    _: 1
  }, 8, ["externalTo", "class"]))
}
}

})